<template>
  <div class="title-section">
    <div class="title-section__content">
      <h2 class="title-section__title">
        <slot></slot>
      </h2>
      <div class="title-section__line">
        <svg
          width="40"
          height="4"
          viewBox="0 0 40 4"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 2L40 2"
            stroke="#bf936c"
            stroke-width="3"
            stroke-linecap="round"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TitleSection",

  /**
   * Component props definition
   */
  props: {
    // Add any additional props if needed in the future
  },
};
</script>

<style lang="scss" scoped>
@import "~/scss/include/_commonInclude.scss";

.content .app {
  .title-section {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    // padding: rem(24) 0;

    &__content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: rem(12);
    }

    &__title {
      font-size: rem(40);
      font-weight: 700;
      line-height: 1.2;
      text-align: center;
      color: color(white);
      text-transform: uppercase;
      letter-spacing: rem(4);
      margin: 0;
      // max-width: rem(823);

      @include media-breakpoint-down(md) {
        font-size: rem(24);
        letter-spacing: rem(2);
        // max-width: 90%;
      }

      @include media-breakpoint-down(sm) {
        letter-spacing: rem(1);
      }
    }

    &__line {
      display: flex;
      justify-content: center;
      align-items: center;

      svg {
        width: rem(40);
        height: rem(4);

        path {
          stroke: color(nespressoBrown);
        }
      }
    }
  }
}
</style>
